import { MessageDescriptor } from "@formatjs/intl/src/types";
import { defineMessages, IntlShape } from "react-intl";

import GoalType from "@app/enum/dashboard/GoalType";

const messages = defineMessages({
  [GoalType.MAX_GOAL]: {
    id: "dashboard.goalType.max",
    defaultMessage: "Max Amount",
    description: "Amount field label for max-goals",
  },
  [GoalType.MIN_GOAL]: {
    id: "dashboard.goalType.min",
    defaultMessage: "Goal Amount",
    description: "Amount field label for min-goals",
  },
} as Record<GoalType, MessageDescriptor>);

const getTargetFieldLabel = (intl: IntlShape, goalType: GoalType) =>
  goalType === GoalType.NO_GOAL ? undefined : intl.formatMessage(messages[goalType]);

export default getTargetFieldLabel;
